function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) {
        return Array.from(iter);
    }
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import z from 'zod';
import { defineDocument } from 'sanity-typed-queries';
import { TaxonomyType } from '@stereoagency/constants';
import internationalizedArrayText from '../fragments/internationalizedArrayText.js';
import internationalizedArrayString from '../fragments/internationalizedArrayString.js';
import internationalizedArrayOptionalImage from '../fragments/internationalizedArrayOptionalImage.js';
import documentSlug from '../fragments/documentSlug.js';
var schema = defineDocument('taxonomy', {
    type: {
        title: 'Type',
        type: 'string',
        options: {
            list: Object.values(TaxonomyType)
        },
        validation: function validation(Rule) {
            return Rule.required();
        }
    },
    slug: _object_spread({
        title: 'Slug'
    }, documentSlug.factory()),
    name: {
        title: 'Name',
        type: 'internationalizedArrayString'
    },
    description: {
        title: 'Description',
        type: 'internationalizedArrayText'
    },
    image: {
        title: 'Image',
        type: 'internationalizedArrayOptionalImage'
    }
}, [
    {},
    {},
    {}
]);
var validator = z.object({
    type: z.enum([
        TaxonomyType.DISEASE_AREA
    ].concat(_to_consumable_array(Object.values(TaxonomyType)))),
    slug: documentSlug.validator,
    name: internationalizedArrayString.validator,
    description: internationalizedArrayText.validator,
    image: internationalizedArrayOptionalImage.validator
}).partial();
schema.taxonomy;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=taxonomy.js.map